import { PaymentsList } from '../components/PaymentsList';

export const PaymentsPage = () => {
  return <PaymentsList />;
};
